const ActionTypes = {
    TICKET_SIZE_CREATE_FAILURE: 'TICKET_SIZE_CREATE##FAILURE',
    TICKET_SIZE_CREATE_REQUEST: 'TICKET_SIZE_CREATE##REQUEST',
    TICKET_SIZE_CREATE_SUCCESS: 'TICKET_SIZE_CREATE##SUCCESS',
    TICKET_SIZE_DELETE_FAILURE: 'TICKET_SIZE_DELETE##FAILURE',
    TICKET_SIZE_DELETE_REQUEST: 'TICKET_SIZE_DELETE##REQUEST',
    TICKET_SIZE_DELETE_SUCCESS: 'TICKET_SIZE_DELETE##SUCCESS',
    TICKET_SIZE_ID_FETCH_FAILURE: 'TICKET_SIZE_ID_FETCH##FAILURE',
    TICKET_SIZE_ID_FETCH_REQUEST: 'TICKET_SIZE_ID_FETCH##REQUEST',
    TICKET_SIZE_ID_FETCH_SUCCESS: 'TICKET_SIZE_ID_FETCH##SUCCESS',
    TICKET_SIZE_UPDATE_FAILURE: 'TICKET_SIZE_UPDATE##FAILURE',
    TICKET_SIZE_UPDATE_REQUEST: 'TICKET_SIZE_UPDATE##REQUEST',
    TICKET_SIZE_UPDATE_SUCCESS: 'TICKET_SIZE_UPDATE##SUCCESS',
    TICKET_SIZES_FETCH_FAILURE: 'TICKET_SIZES_FETCH##FAILURE',
    TICKET_SIZES_FETCH_REQUEST: 'TICKET_SIZES_FETCH##REQUEST',
    TICKET_SIZES_FETCH_SUCCESS: 'TICKET_SIZES_FETCH##SUCCESS',
} as const

export default ActionTypes
